import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Icon } from '@iconify/react';

function Help() {
    const navigate = useNavigate();
    return (
        <div className="flex flex-col">
            <div className="w-full">
                <div>
                    {/* Header Section with Gradient Background */}
                    <div className="rounded-3xl mb-4 p-4 bg-gradient-to-r from-pink-400 to-blue-400 min-h-[200px] flex flex-col justify-center">
                        <h1 className="text-white mb-2 text-3xl font-bold">Help Center</h1>
                        <p className="text-white mb-0 text-lg">Hi, all your problem solutions are here</p>
                    </div>

                    {/* Help Options Grid */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        {/* FAQ Section */}
                        <div className="w-full md:w-full">
                            <div className="bg-white rounded-lg shadow-sm border border-gray-100 h-full">
                                <div className="text-center p-4">
                                    <div className="mb-4">
                                        <Icon
                                            icon="fluent:chat-help-24-regular"
                                            width="64"
                                            height="64"
                                            className="text-primary mx-auto"
                                        />
                                    </div>
                                    <h3 className="font-semibold mb-3 text-lg">Frequently Asked Questions</h3>
                                    <p className="text-gray-500 mb-4">
                                        If you have questions, our FAQ section can help! Click on "FAQs" to browse
                                        through common questions and find solutions to your problems. If you
                                        don't find the answer you're looking for, free to raise a ticket and our
                                        support team will assist you.
                                    </p>

                                    <button
                                        onClick={() => navigate('/user/help/faq')}
                                        className="bg-primary hover:bg-primary/90 text-white font-medium py-2 px-4 rounded-lg inline-flex items-center gap-2"
                                    >
                                        <Icon icon="fluent:book-question-mark-24-regular" />
                                        Browse FAQs
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* Ticket Section */}
                        <div className="w-full md:w-full">
                            <div className="bg-white rounded-lg shadow-sm border border-gray-100 h-full">
                                <div className="text-center p-4">
                                    <div className="mb-4">
                                        <Icon
                                            icon="fluent:ticket-24-regular"
                                            width="64"
                                            height="64"
                                            className="text-primary mx-auto"
                                        />
                                    </div>
                                    <h3 className="font-semibold mb-3 text-lg">Ticket</h3>
                                    <p className="text-gray-500 mb-4">
                                        We're here to assist you! If you need help, simply click the "Raise a Ticket"
                                        button to report a problem or ask for assistance. Once your ticket is submitted,
                                        you can click the "Ticket" button to check the status and follow up on your
                                        request.
                                    </p>
                                    <button
                                        onClick={() => navigate('/user/help/ticket')}
                                        className="bg-primary hover:bg-primary/90 text-white font-medium py-2 px-4 rounded-lg inline-flex items-center gap-2">
                                        <Icon icon="fluent:ticket-add-24-regular" />
                                        Raise a Ticket
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Help;